module.exports = __webpack_public_path__ + "static/media/kazoo.6538de5d.svg";